export const RESOURCES = {
  INSURANCE_GUIDES: 'INSURANCE_GUIDES',
  GENIUS_CENTER: 'GENIUS_CENTER',
  HELPFUL_RESOURCES: 'HELPFUL_RESOURCES',
  REVIEWS: 'REVIEWS',
  ABOUT: 'ABOUT',
};



// WEBPACK FOOTER //
// ../src/templates/Footer/constants.js